import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Home.vue'),
  },
  {
    path: '/context',
    name: 'Context',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "context" */ '@/views/ContextSection/Context.vue'
      ),
    redirect: {
      name: 'ContextOverview',
    },
    children: [
      {
        path: 'overview',
        name: 'ContextOverview',
        component: () =>
          import(
            /* webpackChunkName: "context-overview" */ '@/views/ContextSection/Pages/Overview.vue'
          ),
      },
      {
        path: 'drivers',
        name: 'ContextDrivers',
        component: () =>
          import(
            /* webpackChunkName: "context-drivers" */ '@/views/ContextSection/Pages/Drivers/Drivers.vue'
          ),
        redirect: {
          name: 'ContextDriversEconPop',
        },
        children: [
          {
            path: 'economy-population',
            name: 'ContextDriversEconPop',
            component: () =>
              import(
                /* webpackChunkName: "context-drivers-econ-pop" */ '@/views/ContextSection/Pages/Drivers/Subsections/EconPop.vue'
              ),
          },
          {
            path: 'urban-land-use',
            name: 'ContextDriversUrbanLandUse',
            component: () =>
              import(
                /* webpackChunkName: "context-drivers-urban-land-use" */ '@/views/ContextSection/Pages/Drivers/Subsections/UrbanLandUse.vue'
              ),
          },
          {
            path: 'climate-status',
            name: 'ContextDriversClimateStatus',
            component: () =>
              import(
                /* webpackChunkName: "context-drivers-climate-status" */ '@/views/ContextSection/Pages/Drivers/Subsections/ClimateStatus.vue'
              ),
          },
          {
            path: 'energy-water-needs',
            name: 'ContextDriversEnergyWaterNeeds',
            component: () =>
              import(
                /* webpackChunkName: "context-drivers-energy-water" */ '@/views/ContextSection/Pages/Drivers/Subsections/EnergyWaterNeeds.vue'
              ),
          },
          {
            path: 'agricultural-conditions',
            name: 'ContextDriversAgriculturalConditions',
            component: () =>
              import(
                /* webpackChunkName: "context-drivers-ag-conditions" */ '@/views/ContextSection/Pages/Drivers/Subsections/AgriculturalConditions.vue'
              ),
          },
          {
            path: 'municipal-industrial-conditions',
            name: 'ContextMuniIndustrialConditions',
            component: () =>
              import(
                /* webpackChunkName: "context-drivers-muni-ind-conds" */ '@/views/ContextSection/Pages/Drivers/Subsections/MunicipalIndustrialConditions.vue'
              ),
          },
          {
            path: 'water-efficiency-tech',
            name: 'ContextDriversWaterEfficiencyTech',
            component: () =>
              import(
                /* webpackChunkName: "context-drivers-water-eff-tech" */ '@/views/ContextSection/Pages/Drivers/Subsections/AvailWaterEfficiencyTech.vue'
              ),
          },
          {
            path: 'social-values',
            name: 'ContextDriversSocialVals',
            component: () =>
              import(
                /* webpackChunkName: "context-drivers-soc-vals" */ '@/views/ContextSection/Pages/Drivers/Subsections/SocialValues.vue'
              ),
          },
          {
            path: 'regulatory-constraints',
            name: 'ContextDriversRegConstraints',
            component: () =>
              import(
                /* webpackChunkName: "context-drivers-reg-const" */ '@/views/ContextSection/Pages/Drivers/Subsections/RegulatoryConstraints.vue'
              ),
          },
        ],
      },
      {
        path: 'result-types',
        name: 'ContextResultTypes',
        component: () =>
          import(
            /* webpackChunkName: "context-result-types" */ '@/views/ContextSection/Pages/ResultTypes/ResultTypes.vue'
          ),
        redirect: {
          name: 'keyDefinitions',
        },
        children: [
          {
            path: 'key-definitions',
            name: 'keyDefinitions',
            component: () =>
              import(
                /* webpackChunkName: "context-result-types-key-defs" */ '@/views/ContextSection/Pages/ResultTypes/Subsections/KeyDefinitions.vue'
              ),
          },
          {
            path: 'agricultural-demand',
            name: 'agriculturalDemand',
            component: () =>
              import(
                '@/views/ContextSection/Pages/ResultTypes/Subsections/AgriculturalDemand.vue'
              ),
          },
          {
            path: 'municipal-and-industrial-demand',
            name: 'municipalIndustrialDemand',
            component: () =>
              import(
                '@/views/ContextSection/Pages/ResultTypes/Subsections/MunicipalIndustrialDemand.vue'
              ),
          },
          {
            path: 'agricultural-risk',
            name: 'agriculturalRisk',
            component: () =>
              import(
                '@/views/ContextSection/Pages/ResultTypes/Subsections/AgriculturalRisk.vue'
              ),
          },
          {
            path: 'municipal-and-industrial-risk',
            name: 'municipalIndustrialRisk',
            component: () =>
              import(
                '@/views/ContextSection/Pages/ResultTypes/Subsections/MunicipalIndustrialRisk.vue'
              ),
          },
          {
            path: 'environmental-recreational-risk',
            name: 'environmentalRecreationRisk',
            component: () =>
              import(
                '@/views/ContextSection/Pages/ResultTypes/Subsections/EnvironmentalRecreationRisk.vue'
              ),
          },
          {
            path: 'other-result-types',
            name: 'otherResultTypes',
            component: () =>
              import(
                '@/views/ContextSection/Pages/ResultTypes/Subsections/OtherResultTypes.vue'
              ),
          },
        ],
      },

      {
        path: 'sectors',
        name: 'ContextSectors',
        component: () =>
          import(
            /* webpackChunkName: "context-sectors" */ '@/views/ContextSection/Pages/Sectors/Sectors.vue'
          ),
        redirect: {
          name: 'municipalIndustrial',
        },
        children: [
          {
            path: 'municipal-industrial',
            name: 'municipalIndustrial',
            component: () =>
              import(
                /* webpackChunkName: "context-sectors-muni-ind" */ '@/views/ContextSection/Pages/Sectors/Subsections/MunicipalIndustrial.vue'
              ),
          },
          {
            path: 'agricultural-sector',
            name: 'agriculturalSector',
            component: () =>
              import(
                /* webpackChunkName: "context-sectors-muni-ind" */ '@/views/ContextSection/Pages/Sectors/Subsections/AgriculturalSector.vue'
              ),
          },
          {
            path: 'environment-recreational-sector',
            name: 'envRecSector',
            component: () =>
              import(
                /* webpackChunkName: "context-sectors-muni-ind" */ '@/views/ContextSection/Pages/Sectors/Subsections/EnvironmentRecSector.vue'
              ),
          },
          {
            path: 'overlap-in-sectors',
            name: 'overlapSector',
            component: () =>
              import(
                /* webpackChunkName: "context-sectors-muni-ind" */ '@/views/ContextSection/Pages/Sectors/Subsections/OverlapSector.vue'
              ),
          },
        ],
      },
      {
        path: 'references',
        name: 'ContextReferences',
        component: () =>
          import(
            /* webpackChunkName: "context-references" */ '@/views/ContextSection/Pages/References.vue'
          ),
      },
    ],
  },
  {
    path: '/data',
    name: 'Data',
    component: () =>
      import(/* webpackChunkName: "data" */ '../views/DataSection/Data.vue'),
  },
  {
    path: '/map',
    name: 'Map',
    component: () =>
      import(/*webpackChunkName: "map" */ '@/views/MapSection/MapView.vue'),
  },
  {
    path: '/tools',
    name: 'Tools',
    component: () =>
      import(/* webpackChunkName: "tools" */ '../views/Tools.vue'),
    redirect: {
      name: 'ContextInteractiveTool',
    },
    children: [
      {
        path: 'interactive-tool',
        name: 'ContextInteractiveTool',
        component: () =>
          import(
            /* webpackChunkName: "context-interactive-tool" */ '@/views/ContextSection/Pages/InteractiveTool/InteractiveTool.vue'
          ),
      },
      {
        path: 'scenarios',
        name: 'ContextScenarios',
        component: () =>
          import(
            /* webpackChunkName: "context-drivers" */ '@/views/ContextSection/Pages/Scenarios/Scenarios.vue'
          ),
        redirect: {
          name: 'ContextScenarioPlanning',
        },
        children: [
          {
            path: 'planning',
            name: 'ContextScenarioPlanning',
            component: () =>
              import(
                /* webpackChunkName: "context-scenarios-planning" */ '@/views/ContextSection/Pages/Scenarios/Subsections/Planning.vue'
              ),
          },
          {
            path: 'scenario-descriptions',
            name: 'ContextScenarioDescriptions',
            component: () =>
              import(
                /* webpackChunkName: "context-scenarios-planning-scenario-descriptions" */ '@/views/ContextSection/Pages/Scenarios/Subsections/ScenarioDescriptions.vue'
              ),
            redirect: 'ContextScenarioBaseline',
            children: [
              {
                path: 'baseline',
                name: 'ContextScenarioBaseline',

                meta: {
                  scenario: 'Baseline',
                  scenarioAlt: 'baseline',
                  sideImg: 'Scenarios_Baseline.jpg',
                  next: 'ContextScenarioA',
                  prev: 'ContextScenarioPlanning',
                },
              },
              {
                path: 'scenario-a',
                name: 'ContextScenarioA',

                meta: {
                  scenario: 'Business as Usual',
                  scenarioAlt: 'scenarioA',
                  imageId: 'business-as-usual.svg',
                  sideImg: 'Scenarios_Business_As_Usual.jpg',
                  next: 'ContextScenarioB',
                  prev: 'ContextScenarioBaseline',
                },
              },
              {
                path: 'scenario-b',
                name: 'ContextScenarioB',

                meta: {
                  scenario: 'Weak Economy',
                  scenarioAlt: 'scenarioB',
                  sideImg: 'Scenarios_Weak_Economy.jpg',
                  imageId: 'weak-economy.svg',
                  next: 'ContextScenarioC',
                  prev: 'ContextScenarioA',
                },
              },
              {
                path: 'scenario-c',
                name: 'ContextScenarioC',
                meta: {
                  scenario: 'Cooperative Growth',
                  scenarioAlt: 'scenarioC',
                  imageId: 'cooperative-growth.svg',
                  sideImg: 'Scenarios_Cooperative_Growth.jpg',
                  next: 'ContextScenarioD',
                  prev: 'ContextScenarioB',
                },
              },
              {
                path: 'scenario-d',
                name: 'ContextScenarioD',
                meta: {
                  scenario: 'Adaptive Innovation',
                  scenarioAlt: 'scenarioD',
                  imageId: 'adaptive-innovation.svg',
                  sideImg: 'Scenarios_Adaptive_Innovation.jpg',
                  next: 'ContextScenarioE',
                  prev: 'ContextScenarioC',
                },
              },
              {
                path: 'scenario-e',
                name: 'ContextScenarioE',

                meta: {
                  scenario: 'Hot Growth',
                  scenarioAlt: 'scenarioE',
                  imageId: 'hot-growth.svg',
                  sideImg: 'Scenarios_Hot_Growth.jpg',
                  next: undefined,
                  prev: 'ContextScenarioD',
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/solutions',
    name: 'Solutions',
    component: () =>
      import(
        /* webpackChunkName: "solutions" */ '../views/SolutionsSection/Solutions.vue'
      ),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
